var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8475 11.5331C23.6331 11.2398 18.5245 4.35156 11.9999 4.35156C5.47529 4.35156 0.36647 11.2398 0.152297 11.5328C-0.0507657 11.8111 -0.0507657 12.1885 0.152297 12.4667C0.36647 12.76 5.47529 19.6483 11.9999 19.6483C18.5245 19.6483 23.6331 12.76 23.8475 12.467C24.0508 12.1888 24.0508 11.8111 23.8475 11.5331ZM11.9999 18.0659C7.19383 18.0659 3.03127 13.494 1.79907 11.9994C3.02968 10.5034 7.18351 5.93397 11.9999 5.93397C16.8057 5.93397 20.968 10.505 22.2007 12.0005C20.9701 13.4963 16.8163 18.0659 11.9999 18.0659Z",
    fill: "#696B73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 7.25269C9.3826 7.25269 7.25293 9.38236 7.25293 12C7.25293 14.6176 9.3826 16.7472 12.0002 16.7472C14.6178 16.7472 16.7475 14.6176 16.7475 12C16.7475 9.38236 14.6178 7.25269 12.0002 7.25269ZM12.0002 15.1648C10.255 15.1648 8.83538 13.7451 8.83538 12C8.83538 10.2548 10.2551 8.83514 12.0002 8.83514C13.7453 8.83514 15.165 10.2548 15.165 12C15.165 13.7451 13.7454 15.1648 12.0002 15.1648Z",
    fill: "#696B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1c539f67ea3db2e85f9dcc06620fdb76.svg";
export { ForwardRef as ReactComponent };